import { useEffect } from 'react';
import { setDocumentTitle } from '../../utils/htmlUtils';

const useDocumentTitle = (title: string | undefined): void => {
  if (title && document.title !== title) {
    setDocumentTitle(title);
  }

  useEffect(() => {
    return () => {
      document.title = 'CreditSights';
    };
  }, []);
};

export default useDocumentTitle;
